import * as React from "react"
import { theme } from "../../theme/theme"
import { View } from "react-native"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { liveButtonStyle } from "../components-web/TrackToggleM"
// @ts-ignore
import TouchableRippleM from "@common/components/button/TouchableRippleM"

export const LayoutToggleM = ({ pinnedMode, setPinnedMode }) => {

    return (
        <TouchableRippleM style={{
            ...liveButtonStyle,
            marginLeft: 5
        }}
                          onPress={() => {
                              setPinnedMode(!pinnedMode)
                          }}>
            {pinnedMode
                ? <FontAwesome5 name={"th"} size={24} color={theme.colors.primary} />
                : <View style={{ justifyContent: "center" }}>
                    <FontAwesome5 name={"square"}
                                  solid
                                  size={20}
                                  style={{
                                      marginRight: 4,
                                  }}
                                  color={theme.colors.primary} />
                    <FontAwesome5 name={"grip-vertical"}
                                  solid
                                  size={18}
                                  style={{
                                      position: "absolute",
                                      right: -2,
                                  }}
                                  color={theme.colors.primary} />
                </View>}
        </TouchableRippleM>
    )
}